"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _babelHelperVueJsxMergeProps = _interopRequireDefault(require("@vue/babel-helper-vue-jsx-merge-props"));
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.object.assign.js");
var _utils = require("../utils");
var _functional = require("../utils/functional");
var _popup = require("../mixins/popup");
var _icon = _interopRequireDefault(require("../icon"));
var _loading = _interopRequireDefault(require("../loading"));
var _popup2 = _interopRequireDefault(require("../popup"));
// Types

var _use = (0, _utils.use)('actionsheet'),
  sfc = _use[0],
  bem = _use[1];
function Actionsheet(h, props, slots, ctx) {
  var title = props.title,
    cancelText = props.cancelText,
    nameKey = props.nameKey,
    subnameKey = props.subnameKey;
  var onCancel = function onCancel() {
    (0, _functional.emit)(ctx, 'input', false);
    (0, _functional.emit)(ctx, 'cancel');
  };
  var Option = function Option(item, index) {
    return h("div", {
      "class": [bem('item', {
        disabled: item.disabled || item.loading,
        last: index === props.actions.length - 1
      }), item.className],
      "on": {
        "click": function click(event) {
          event.stopPropagation();
          if (!item.disabled && !item.loading) {
            if (item.callback) {
              item.callback(item);
            }
            (0, _functional.emit)(ctx, 'select', item, index);
          }
        }
      }
    }, [[item.loading && h(_loading.default, {
      "class": bem('icon'),
      "attrs": {
        "size": "20px"
      }
    }), item.icon && !item.loading && h(_icon.default, {
      "attrs": {
        "name": item.icon,
        "classPrefix": item.classPrefix || (item.zziconfont ? 'zziconfont' : undefined),
        "size": "20px"
      },
      "class": bem('icon')
    }), h("span", {
      "class": bem('name')
    }, [item[nameKey]]), item[subnameKey] && h("span", {
      "class": bem('subname')
    }, [item[subnameKey]])]]);
  };
  return h(_popup2.default, (0, _babelHelperVueJsxMergeProps.default)([{
    "class": bem(),
    "attrs": {
      "value": props.value,
      "position": "bottom",
      "overlay": props.overlay,
      "lazyRender": props.lazyRender,
      "getContainer": props.getContainer,
      "lockScroll": props.lockScroll,
      "closeOnClickOverlay": props.closeOnClickOverlay
    },
    "on": {
      "input": function input(value) {
        (0, _functional.emit)(ctx, 'input', value);
      }
    }
  }, (0, _functional.inherit)(ctx, true)]), [title && h("div", {
    "class": bem('header')
  }, [title]), slots.default ? h("div", {
    "class": bem('content')
  }, [slots.default()]) : props.actions.map(Option), cancelText && h("div", {
    "class": bem('cancel'),
    "on": {
      "click": onCancel
    }
  }, [cancelText])]);
}
Actionsheet.props = Object.assign({}, _popup.PopupMixin.props, {
  title: String,
  actions: Array,
  cancelText: String,
  overlay: {
    type: Boolean,
    default: true
  },
  closeOnClickOverlay: {
    type: Boolean,
    default: true
  },
  nameKey: {
    type: String,
    default: 'name'
  },
  subnameKey: {
    type: String,
    default: 'subname'
  }
});
var _default = sfc(Actionsheet);
exports.default = _default;